import React from 'react';
import '../styles/modern.css';

interface GlassPanelProps {
  children?: React.ReactNode;
  padding?: number | string;
  hover?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  style?: React.CSSProperties;
  className?: string;
}

export default function GlassPanel({
  children,
  padding = 16,
  hover = true,
  onClick,
  style = {},
  className = '',
}: GlassPanelProps) {
  const classes = [
    'glass-panel',
    hover ? 'glass-panel--hoverable' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      onClick={onClick}
      style={{ padding, cursor: onClick ? 'pointer' : undefined, ...style }}
    >
      {children}
    </div>
  );
}
